const initState = {
    search_jobs: [],
    filtered_jobs: [], // Filtered job list
    filter: "", 
    totalFilteredJobCount: 0, 
}

export const reducer = (globalState = initState, action) => {
    switch (action.type) {
        case "SET_SEARCHJOBS": {
            return {
                ...globalState,
                search_jobs:action.payload
            }
        }
        case "SET_FILTER": {
            return {
                ...globalState,
                filter: action.payload // Store the filter value
            };
        }
        case 'SET_TOTAL_FILTERED_JOB_COUNT':
            return {
                ...globalState,
                totalFilteredJobCount: action.payload,
            };
        default:
          return globalState;
    }
}

export default reducer